


export const disclaimerData = [
   
    {
        "title": "Trading Requirements",
        "sub": [
            {
                "title": "Computer",
                "desc": "The recommended specifications for optimal bot performance starts from 8GB of RAM and an Intel i5 processor or equivalent."
            },
            {
                "title": "Internet Speed",
                "desc": "A stable internet connection is essential. A minimum internet speed of 12 Mbps is recommended to ensure smooth operation."
            },
            {
                "title": "Position Size",
                "desc": "Avoid trading solely to cover network fees. We recommend starting with a minimum position size of $10 per trade to begin seeing profits."
            }
        ]
    },
    {
        title: 'General Disclaimer',
        desc: "The trading bot provided is an automated tool designed to execute trades based on predefined strategies. While the bot is intended to assist in cryptocurrency trading, it is important to understand that all trades, strategies, and actions are based on market conditions and algorithmic decisions. The bot does not guarantee profits and cannot account for sudden market fluctuations, news events, or other factors that may impact trading."
    },
    {
        title: 'No Financial Advice',
        desc: "The trading bot is not intended to offer financial advice. The performance and results of the bot may vary, and past performance is not indicative of future results. You should carefully assess your risk tolerance and consider seeking advice from a qualified financial advisor before engaging in cryptocurrency trading."
    },
    {
        title: 'Market Risks',
        desc: "Cryptocurrency markets are highly volatile, speculative, and subject to rapid changes. Prices can fluctuate dramatically in short periods, and market conditions can change without warning. As a result, there is a risk of losing your investment, and you should only trade with capital that you can afford to lose."
    },
    {
        title: 'Technical and Operational Risks',
        desc: "While we take measures to ensure the bot's functionality, there are inherent risks associated with using automated systems. These include but are not limited to bugs, server downtime, connectivity issues, and technical failures. In such cases, the bot may not perform as expected or may fail to execute trades."
    },

    {
        title: 'Risks Specific to Cryptocurrency Trading',
        sub: [
            {
                title: 'Volatility',
                desc: ' Cryptocurrencies can experience extreme price volatility, leading to significant gains or losses within short timeframes.'
            },
            {
                title: 'Security Risks',
                desc: 'Cryptocurrency exchanges and wallets are vulnerable to hacking, phishing attacks, and other forms of cybercrime. We recommend using secure methods for storing your assets and only trading on reputable platforms.'
            },
            {
                title: 'Regulatory Risks',
                desc: 'The cryptocurrency market is subject to varying levels of regulation and may change over time. Changes in regulations or government policies may affect your ability to trade or your assets value.'
            },
        ],
        
    },
    {
        title: 'No Guarantee of Profits',
        desc: "The use of this trading bot does not guarantee any profits. While the bot is designed to execute trades based on its strategy, market conditions can cause significant losses, and the bot cannot predict or control future market movements."
    },
    {
        title: 'User Responsibility',
        desc:'By using this bot, you acknowledge that you are solely responsible for your decisions, actions, and trades made through the system. We do not take responsibility for any losses, damages, or issues that arise from the use of the bot or cryptocurrency trading.'
    },
    {
        title: 'Changes to Service',
        desc:'We reserve the right to modify, update, or discontinue the bot and its functionalities at any time without prior notice.'
    },
    
]